export default __webpack_public_path__ + "18b2f3bde347ae459fd41d61e7a43ec9.svg";